<template>
  <app-data-editor
    :id="id"
    title="Редактирование категории товара"
    resource="product-categories"
    :elements="elements"
    add-message="Категория добавлена"
    edit-message="Категория изменена"
    @change="(payload) => isChanged = payload"
  />
</template>

<script>
import mixin from "./../../mixins/confirm-cancel-changes.js";
export default {
  mixins: [mixin],
  props: ["id"],
  data() {
    return {
      elements: [
        [
          {
            title: "Наименование",
            name: "title",
            control: {
              type: "title-text",
              required: true,
              rules: [
                (v) => !!v || "Наименование обязательно к заполнению",
                (v) =>
                  v.length >= 1 ||
                  "Наименование должно содержать не менее 1-го символа",
              ],
            },
            default: "",
          },
          {
            title: "Тип",
            name: "type",
            control: {
              type: "enum",
              resource: "product-category-types",
              required: true,
              clearable: false,
            },
          },
          {
            title: "Объемный тарифные вес, кг/м3",
            name: "volumeRateWeigth",
            control: {
              type: "number",
            },
            default: 0,
          },
        ],
        [
          {
            title: "Тариф - Италия, $",
            name: "rateItaly",
            control: {
              type: "number",
            },
            default: 0,
          },
          {
            title: "Тариф - Германия, $",
            name: "rateGermany",
            control: {
              type: "number",
            },
            default: 0,
          },
          {
            title: "Тариф - США, $",
            name: "rateUSA",
            control: {
              type: "number",
            },
            default: 0,
          },
        ],
        [
          {
            title: "Описание",
            name: "description",
            control: {
              type: "text",
            },
            default: "",
          },
        ],
      ],
    };
  },
};
</script>
